import { globalObject, willSyntheticsInjectRum, SKIPPED } from '@datadog/browser-core';
export function startRUMInternalContext(hooks) {
  var browserWindow = globalObject;
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var startTime = _ref.startTime;
    var internalContext = getRUMInternalContext(startTime);

    if (!internalContext) {
      return SKIPPED;
    }

    return internalContext;
  });
  hooks.register(1
  /* HookNames.AssembleTelemetry */
  , function (_ref2) {
    var startTime = _ref2.startTime;

    var _a, _b;

    var internalContext = getRUMInternalContext(startTime);

    if (!internalContext) {
      return SKIPPED;
    }

    return {
      application: {
        id: internalContext.application_id
      },
      view: {
        id: (_a = internalContext.view) === null || _a === void 0 ? void 0 : _a.id
      },
      action: {
        id: (_b = internalContext.user_action) === null || _b === void 0 ? void 0 : _b.id
      }
    };
  });

  function getRUMInternalContext(startTime) {
    var willSyntheticsInjectRumResult = willSyntheticsInjectRum();
    var rumSource = willSyntheticsInjectRumResult ? browserWindow.DD_RUM_SYNTHETICS : browserWindow.DD_RUM;
    var rumContext = getInternalContextFromRumGlobal(startTime, rumSource);

    if (rumContext) {
      return rumContext;
    }
  }

  function getInternalContextFromRumGlobal(startTime, rumGlobal) {
    if (rumGlobal && rumGlobal.getInternalContext) {
      return rumGlobal.getInternalContext(startTime);
    }
  }
}